import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from 'react';
import axios from 'axios';
import { useMutableRef } from '@carnica/utils/hooks';
import { deleteCookie } from '@beef/utils';
import { endpoints, fetchAuthToken, getEndpoints, getHeaders, getUserAgentHeaders, instance } from "../../../../shared/api";
import { FSMStages, useAppDispatch, useAppSelector, useFSM } from "../../../../shared/model";
import { selectCaptchaAccessToken, setCaptchaAccessToken } from "../../../../entities/captcha/model";
import { selectChatCofig, selectIsChatOpen, setErrorReason, setErrorScreenType, setWidgetConfig } from "../../../../entities/settings/model";
import { CAPTCHA_ACCESS_COOKIE_NAME, ErrorReason, ErrorScreenType } from "../../../../shared/config";
import { getZoneType, isAllowedPathForRetry, isTriggeredErrorScreen } from "./utils";
export var useRequestInterceptor = function useRequestInterceptor() {
  var dispatch = useAppDispatch();
  var _useFSM = useFSM(),
    changeStage = _useFSM.changeStage;
  var tokenData = useAppSelector(selectCaptchaAccessToken);
  var chatConfig = useAppSelector(selectChatCofig);
  var isOpen = useAppSelector(selectIsChatOpen);
  var chatConfigRef = useMutableRef(chatConfig);
  var tokenDataRef = useMutableRef(tokenData);
  var getRequestHeaders = function getRequestHeaders(token) {
    var _chatConfigRef$curren = chatConfigRef.current,
      userData = _chatConfigRef$curren.userData,
      authType = _chatConfigRef$curren.authType,
      authZoneConfig = _chatConfigRef$curren.authZoneConfig;
    return _objectSpread(_objectSpread({}, getHeaders({
      token: token !== null && token !== void 0 ? token : authZoneConfig.zoneType === 'unauthorized' ? tokenDataRef.current : userData === null || userData === void 0 ? void 0 : userData.token,
      authType: authType,
      zoneType: authZoneConfig === null || authZoneConfig === void 0 ? void 0 : authZoneConfig.zoneType
    })), getUserAgentHeaders());
  };
  var setTokenStore = function setTokenStore(token, isAuthZone) {
    if (!isAuthZone) {
      dispatch(setCaptchaAccessToken(token));
    } else {
      dispatch(setWidgetConfig(_objectSpread(_objectSpread({}, chatConfigRef.current), {}, {
        userData: {
          token: token
        }
      })));
    }
  };
  useEffect(function () {
    instance.interceptors.request.use( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
        var _config$url, _config$url2;
        var isRequestGetTokenAuthZone, baseUrl, urlFileDownload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isRequestGetTokenAuthZone = (_config$url = config.url) === null || _config$url === void 0 ? void 0 : _config$url.includes(endpoints.tokenAuthZone.gettoken);
              baseUrl = isRequestGetTokenAuthZone ? window.location.origin : getEndpoints(chatConfigRef.current.baseUrl).http;
              config.baseURL = baseUrl;
              if ((_config$url2 = config.url) !== null && _config$url2 !== void 0 && _config$url2.includes(endpoints.file.download) && config.url) {
                urlFileDownload = new URL(config.url);
                config.url = "".concat(baseUrl).concat(urlFileDownload.pathname).concat(urlFileDownload.search || '');
              }
              config.headers = getRequestHeaders();
              return _context.abrupt("return", config);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), function (error) {
      return Promise.reject(error);
    });
    instance.defaults.headers = getRequestHeaders();
    instance.defaults.baseURL = getEndpoints(chatConfigRef.current.baseUrl).http;
    instance.interceptors.response.use(function (response) {
      return response;
    }, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error) {
        var _error$config$url, _error$response, _chatConfigRef$curren2;
        var zone, isAuthZone, originalRequest, triggerData, token, refreshScopeTrigger;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              zone = getZoneType(chatConfigRef.current, error.config);
              isAuthZone = zone === 'authorized';
              originalRequest = error.config;
              triggerData = isTriggeredErrorScreen(error, chatConfigRef.current);
              if ((_error$config$url = error.config.url) !== null && _error$config$url !== void 0 && _error$config$url.includes(endpoints.captcha.refresh)) {
                deleteCookie(CAPTCHA_ACCESS_COOKIE_NAME);
              }
              if (!triggerData[0]) {
                _context2.next = 10;
                break;
              }
              changeStage(FSMStages.ERROR);
              dispatch(setErrorScreenType(triggerData[1]));
              dispatch(setErrorReason(triggerData[2]));
              return _context2.abrupt("return", Promise.reject(error));
            case 10:
              if (!((error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) !== 401 || originalRequest._retry || isAllowedPathForRetry(error.config.url, (_chatConfigRef$curren2 = chatConfigRef.current) === null || _chatConfigRef$curren2 === void 0 || (_chatConfigRef$curren2 = _chatConfigRef$curren2.apiSettings) === null || _chatConfigRef$curren2 === void 0 ? void 0 : _chatConfigRef$curren2.apiHistoryVersion))) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("return", Promise.reject(error));
            case 12:
              originalRequest._retry = true;
              _context2.prev = 13;
              _context2.next = 16;
              return fetchAuthToken(isAuthZone);
            case 16:
              token = _context2.sent;
              if (!token) {
                _context2.next = 23;
                break;
              }
              originalRequest.headers = _objectSpread(_objectSpread({}, originalRequest.headers), getRequestHeaders(token));
              setTokenStore(token, isAuthZone);
              _context2.next = 22;
              return axios(originalRequest);
            case 22:
              return _context2.abrupt("return", _context2.sent);
            case 23:
              throw new Error('token is undefined');
            case 26:
              _context2.prev = 26;
              _context2.t0 = _context2["catch"](13);
              // TODO: экран ошибки
              if (isAuthZone) {
                changeStage(FSMStages.ERROR);
                dispatch(setErrorScreenType(ErrorScreenType.LOAD));
                dispatch(setErrorReason(ErrorReason.HISTORY_LOAD));
              } else {
                refreshScopeTrigger = isTriggeredErrorScreen(_context2.t0, chatConfigRef.current);
                if (refreshScopeTrigger[0]) {
                  changeStage(FSMStages.ERROR);
                  dispatch(setErrorScreenType(refreshScopeTrigger[1]));
                  dispatch(setErrorReason(refreshScopeTrigger[2]));
                } else {
                  changeStage(FSMStages.CAPTCHA_NEEDED);
                }
              }
            case 29:
              return _context2.abrupt("return", Promise.reject(error));
            case 30:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[13, 26]]);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  }, [isOpen, chatConfig.authZoneConfig, chatConfig.authType, tokenData, chatConfig.userData]);
};